import api from '@/assets/js/api.js'

const state = {
  categories: [],
  busyMethod: {}
}

const getters = {
  global_get_categories: state => {
    return state.categories
  },
  global_is_busy_method: state => {
    return method => {
      return state.busyMethod.hasOwnProperty(method)
    }
  }
}

const mutations = {
  GLOBAL_SET_CATEGORIES (state, categories) {
    state.categories = categories
  },
  GLOBAL_SET_BUSY_METHOD (state, met) {
    state.busyMethod[met] = true
  },
  GLOBAL_RESET_BUSY_METHOD (state) {
    state.busyMethod = {}
  },
  GLOBAL_UNSET_BUSY_METHOD (state, met) {
    if (state.busyMethod.hasOwnProperty(met)) {
      delete state.busyMethod[met]
    }
  }
}

const actions = {
  getGlobalCategories ({ commit, rootGetters }) {
    if (!rootGetters.global_is_busy_method('getGlobalCategories')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getGlobalCategories')
      api.getCategories(1000).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getGlobalCategories')
          console.log(response.data)
          commit('GLOBAL_SET_CATEGORIES', response.data)
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getGlobalCategories')
          console.log(error)
        }
      )
    }
  },
  getMore ({ commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getMore')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getMore')
      api.fromPagination(payload.url).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getMore')
          console.log(response)
          if (payload.commit) {
            commit(payload.commit, response)
          }
          if (payload.cb) {
            payload.cb(response)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getMore')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js